/*
 * Apparition douce des blocs marqués data-reveal quand ils entrent dans
 * l'écran. Un seul IntersectionObserver, aucune écoute du défilement.
 * Les éléments déjà visibles au chargement sont marqués avant que la classe
 * co-js ne masque le reste : pas de clignotement, pas de décalage (CLS).
 * Quand un bloc apparaît, tout ce qui le précède dans la page est affiché
 * aussi : un défilement rapide (ou le défilement doux du thème) peut sauter
 * un bloc sans que l'observateur le voie, il ne doit jamais rester invisible.
 * Un onglet ouvert en arrière-plan ne reçoit pas d'intersections : on
 * refait le tri des éléments visibles quand il revient au premier plan.
 * Désactivé dans l'éditeur de thème et quand les animations sont réduites.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var els = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
  if (!els.length) return;

  var io;
  function show(el) {
    if (el.classList.contains('is-in')) return;
    el.classList.add('is-in');
    if (io) io.unobserve(el);
  }
  function showVisible() {
    var limit = window.innerHeight * 0.96;
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < limit) show(el);
    });
  }

  showVisible();
  document.documentElement.classList.add('co-js');

  io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting && entry.boundingClientRect.bottom > 0) return;
      var k = els.indexOf(entry.target);
      for (var i = 0; i <= k; i++) show(els[i]);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });

  els.forEach(function (el) {
    if (!el.classList.contains('is-in')) io.observe(el);
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) showVisible();
  });
  window.addEventListener('pageshow', showVisible);
})();